import React from 'react';
import { Wrapper, Active } from './styled';

interface Props {
  positionOf: Array<number>;
}

export const BreadCrumb: React.FC<Props> = ({positionOf}) => {

  const [stepCurrent, stepTotal] = positionOf;

  return (
    <Wrapper><Active>Paso {stepCurrent}</Active> de {stepTotal}</Wrapper>
  )
};
